import { handleHourFromTitle, handleSpaceBeforeAMOrPM } from "../../../helpers/utils";
import { useTrackContext } from "../../../hooks/useTrackContext";
import { IGVariant, TGameOptions } from "../../../types";
interface IProps {
  title: string;
  price: string;
  variantId?: string;
  isGameVR?: boolean;
  vrGameName?: TGameOptions | undefined;
  variant?: IGVariant;
}

export function SampleVariantsBlock({ title, price, isGameVR, variant }: IProps) {
  const { trackSelectionOption } = useTrackContext();

  const handlePriceColor = (xPrice: string) => {
    const xNumber = parseFloat(xPrice);
    if (trackSelectionOption.title === "MAIN_TRACK" || trackSelectionOption.title === "VIRTUAL_REALITY" || trackSelectionOption.title === "JUNIOR_TRACK") {
      if (xNumber <= 15) {
        return "tw-bg-[#40BFFF]";
      } else if (xNumber <= 19) {
        return "tw-bg-[#40BFFF]";
      } else if (xNumber <= 24) {
        return "tw-bg-[#8A75FF]";
      } else if (xNumber <= 29) {
        return "tw-bg-[#8A75FF]";
      } else if (xNumber <= 39) {
        return "tw-bg-[#C03FFF]";
      } else if (xNumber <= 49) {
        return "tw-bg-[#E632E5]";
      } else if (xNumber <= 59) {
        return "tw-bg-[#510EA8]";
      } else if (xNumber <= 69) {
        return "tw-bg-[#510EA8]";
      }
    } else if (trackSelectionOption.title === "MINI_TRACK") {
      if (xNumber <= 9) {
        return "tw-bg-[#40BFFF]";
      } else if (xNumber <= 14) {
        return "tw-bg-[#40BFFF]";
      } else if (xNumber <= 15) {
        return "tw-bg-[#8A75FF]";
      } else if (xNumber <= 19) {
        return "tw-bg-[#C03FFF]";
      } else if (xNumber <= 24) {
        return "tw-bg-[#E632E5]";
      } else if (xNumber <= 29) {
        return "tw-bg-[#510EA8]";
      }
    }
  };

  return (
    <div
      className={`tw-text-center tw-cursor-pointer tw-flex tw-flex-col tw-relative lg:tw-max-w-[140px] xl:tw-max-w-[160px] lg:tw-max-h-[55px] lg:tw-w-full lg:tw-h-full tw-m-[2px] tw-font-medium tw-justify-center tw-rounded-lg tw-overflow-hidden`}
    >
      <div className={`tw-text-[18px] tw-font-[500] tw-uppercase tw-relative tw-whitespace-nowrap tw-py-[2px] tw-px-[20px] lg:tw-px-[0] tw-bg-white tw-text-[#393B41]`}>
        {handleSpaceBeforeAMOrPM(handleHourFromTitle(title))}
      </div>
      <div className="tw-flex tw-items-center">
        {isGameVR ? (
          <>
            <div className={`tw-w-full tw-font-bold tw-text-white tw-text-center tw-text-[14px] tw-whitespace-nowrap ${handlePriceColor(price)}`}>
              $<span>{parseFloat(price).toFixed(0)}</span>
            </div>
            {variant && variant.quantityAvailable && (
              <div className={`tw-w-full tw-font-bold tw-text-white tw-text-center tw-text-[12px] tw-px-2 tw-whitespace-nowrap tw-bg-black`}>
                <span>{variant.quantityAvailable} spots left</span>
              </div>
            )}
          </>
        ) : (
          <>
            <div className={`tw-w-full tw-font-bold tw-text-white tw-text-center tw-text-[14px] tw-whitespace-nowrap ${handlePriceColor(price)}`}>
              $<span>{parseFloat(price).toFixed(0)}</span>
            </div>
            {variant && variant.quantityAvailable && (
              <div className={`tw-w-full tw-font-bold tw-text-white tw-text-center tw-text-[12px] tw-px-2 tw-whitespace-nowrap tw-bg-black`}>
                <span>{variant.quantityAvailable} left</span>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
